import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { TourOverlayComponent } from '../../tour/tour-overlay/tour-overlay.component';
import { TourService } from '../../tour/tour.service';
import { WhatsNewService } from '../../whats-new/whats-new.service';

@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrl: './master-page.component.scss',

  imports: [SidebarComponent, NavbarComponent, RouterModule, TourOverlayComponent],
})
export class MasterPageComponent implements OnInit, AfterViewInit {
  private readonly tourService = inject(TourService);
  private readonly whatsNew = inject(WhatsNewService);

  constructor(private localStorageService: LocalStorageService) {}

  // Lê as novidades pendentes já na abertura: os vídeos delas começam a baixar enquanto o layout
  // assenta, e a modal abre com o vídeo pronto.
  ngOnInit(): void {
    void this.whatsNew.prepare();
  }

  // Tour de boas-vindas no primeiro acesso — espera o layout assentar (sidebar/menu montam com
  // setTimeouts próprios de até ~700ms) antes de apontar spotlight pros elementos.
  ngAfterViewInit(): void {
    // As novidades esperam o tour: duas camadas de overlay ao mesmo tempo atropelam a primeira visita.
    setTimeout(() => {
      // Tour abriu: os vídeos das novidades param de baixar.
      if (this.tourService.autoStartIfFirstAccess()) this.whatsNew.release();
      else void this.whatsNew.showPending();
    }, 1200);
  }
}
